<template>
  <v-layout style="position: absolute; top: 0; left: 0px; right: 0; bottom: 0;">
    <v-dialog v-model="dialog" max-width="90%">
      <div style="position: relative; height: 90vh; background: white;">
        <resource-viewer
          v-if="selectedResourceId"
          :resourceId="selectedResourceId"
        ></resource-viewer>
      </div>
    </v-dialog>
    <v-col style="height: 100%; overflow-y: auto; max-width: 400px; min-width: 315px;">
      <v-list dense color="transparent">
        <v-subheader>Tags</v-subheader>
        <v-list-item v-for="tag in resourceTags" :key="tag.id">
          <v-checkbox
            v-model="selectedTags"
            :label="tag.text + `(${tag.resources ? tag.resources.length : 0})`"
            :value="tag"
            hide-details
            class="mt-1"
          ></v-checkbox>
        </v-list-item>
      </v-list>
    </v-col>
    <v-flex
      class="px-4"
      :style="
        `overflow-y: auto;
              overflow-x: hidden;
              height: 100%;`
      "
    >
      <v-layout>
        <div class="pt-2 pl-2">
          <v-btn icon><v-icon color="primary">add_circle</v-icon></v-btn>
        </div>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-layout>
      <v-data-table
        v-if="currentWorkspaceId"
        v-on:click:row="c.log($event)"
        class="transparent"
        must-sort
        sort-by="createdOn"
        sort-desc
        :search="search"
        :headers="[
          { text: 'Type', value: 'icon' },
          { text: 'Name', value: 'text' },
          { text: 'Permission', value: 'permission' },
          { text: 'Authors' },
          { text: 'Tags', value: 'tags' },
          { text: 'Created On', value: 'createdOn' },
          { text: ' ' }
        ]"
        :items="resources"
      >
        <template v-slot:body="{ items }">
          <tbody>
            <tr
              v-for="item in items"
              :key="item.id"
              :class="{ 'grey lighten-2': selectedItem == item.id }"
              @dblclick="selectedResourceId = item.id"
              @click="selectedItem = item.id"
              draggable="true"
              style="user-select: none;"
            >
              <td width="80">
                <v-icon size="16">
                  {{ item.icon }}
                </v-icon>
              </td>
              <td style="white-space: nowrap; overflow: hidden;max-width: 151px;">
                {{ item.text }}
              </td>
              <td>
                <v-icon size="16">{{ item.permission }}</v-icon>
              </td>
              <td>
                <user-avatar
                  v-for="author in item.authors"
                  :avatarUrl="author.avatar"
                  :key="author.id"
                  size="24"
                ></user-avatar>
              </td>
              <td>{{ item.tags }}</td>
              <td>{{ item.createdOn | formatDate }}</td>
              <td width="180">
                <v-btn text v-if="selectedItem == item.id" @click="selectedResourceId = item.id">
                  VIEW
                </v-btn>
                <v-dialog v-if="selectedItem == item.id" v-model="confirmDeleteModal" width="400">
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on"><v-icon>delete</v-icon></v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      Delete Resource?
                    </v-card-title>
                    <v-card-text>
                      Are you super sure? There ain't no coming back from this.
                    </v-card-text>
                    <v-card-actions>
                      <v-btn color="warning" @click="handleDeleteResource(item.id)"
                        >Yes, Delete Resource</v-btn
                      >
                      <v-btn @click="confirmDeleteModal = false">Cancel</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';

import UserAvatar from '@/components/UserAvatar';
import ResourceViewer from '@/components/ResourceViewer';

export default {
  components: { UserAvatar, ResourceViewer },
  props: ['space'],
  data() {
    return {
      c: console,
      search: null,
      selectedTags: [],
      selectedItem: null,
      selectedResourceId: null,
      confirmDeleteModal: false
    };
  },
  watch: {
    // $route(to, from) {
    //   // react to route changes...
    // },
    active(to, from) {
      if (to != from && this.selectedItem) {
        this.selectedItem = null;
      }
    }
  },
  computed: {
    ...mapGetters('workspaces', ['currentWorkspace', 'workspaceContexts', 'userPermissionIds']),
    ...mapGetters('userWorkspaceLite', [
      'currentUserWorkspaceLite',
      // 'allUserDocuments',
      'workspaceResources'
    ]),
    ...mapState('userWorkspaceLite', ['allUserDocuments']),
    ...mapGetters('components/dragdrop', ['dragging']),
    ...mapState('workspaces', ['currentWorkspaceId']),
    dialog: {
      get() {
        return !!this.selectedResourceId;
      },
      set(v) {
        this.selectedResourceId = v;
      }
    },
    resourceItems() {
      const resources = this.workspaceResources;
      return resources.map(r => {
        const rData = r.resourceData;
        const type = r.resourceData.type;
        const item = {
          id: r.id,
          permission: r.userPermission == 'editing' ? 'edit' : 'visibility',
          authors: r.authors,
          lastOpenedByUser: r.lastOpenedByUser,
          tags: r.tags.toString().replace(',', ', '),
          createdOn: r.createdOn
        };
        if (type == 'webpage') {
          Object.assign(item, {
            icon: 'web',
            text: r.text || rData.title
          });
        } else if (type == 'pdf') {
          Object.assign(item, {
            icon: 'picture_as_pdf',
            text: r.text || rData.name
          });
        } else if (type == 'image') {
          Object.assign(item, {
            icon: 'image',
            thumb: rData.thumbnailUrl,
            text: r.text || rData.name
          });
        }
        return item;
      });
    },
    resources() {
      let w = this.resourceItems;
      if (this.selectedTags.length) {
        let resourceIds = [];
        this.selectedTags.forEach(tag => {
          resourceIds = resourceIds.concat(tag.resources);
        });
        w = w.filter(resource => resourceIds.includes(resource.id));
      }
      return w;
    },
    resourceTags() {
      let t = this.currentWorkspace ? Object.values(this.currentWorkspace.resourceTags) : [];
      return t.sort((a, b) => (a.resources.length < b.resources.length ? 1 : -1));
    }
  },
  methods: {
    ...mapMutations('components/settingsModal', ['setModal']),
    ...mapActions('resources', ['deleteResource']),
    handleDeleteResource(resourceId) {
      this.deleteResource({ resourceId });
      this.confirmDeleteModal = false;
    }
  }
};
</script>

<style>
.workspace-panel .v-expansion-panel-content__wrap {
  width: 100%;
  padding-right: 0px;
}
</style>
